import { Typography } from '@mui/material'
import React from 'react'

import SelectorButton from '@/atoms/SelectorButton/SelectorButton'
import { Stack } from '@/atoms/System'
import styled from '@/styles'
import { DefaultProps } from '@/travelsuit'
import { Locales } from '@/types/locale'

import { useLanguageSelectorTranslation } from './useLanguageSelectorTranlation'

interface IProps extends DefaultProps {
	availableLanguages: Locales[]
	language: Locales
	onChange?(language: Locales, e: React.MouseEvent<HTMLElement>): void
}

const StyledSelectorButton = styled(SelectorButton)`
	padding-left: ${(p) => p.theme.spacing(3)};
	padding-right: ${(p) => p.theme.spacing(3)};
`

export const LanguageSelector: React.FunctionComponent<IProps> = (props) => {
	const { className, language, onChange, availableLanguages } = props
	const translation = useLanguageSelectorTranslation()

	return (
		<Stack className={className} gap={2}>
			{availableLanguages.map((lang) => {
				return (
					<StyledSelectorButton key={lang} selected={lang === language} onClick={(e) => onChange?.(lang, e)}>
						<Stack direction="row" gap={2} alignItems="center" justifyContent="flex-start">
							<Typography variant="subtitle2">{translation.title[lang]}</Typography>
						</Stack>
					</StyledSelectorButton>
				)
			})}
		</Stack>
	)
}
